import React from 'react';
import { Card, CardContent } from "../../tailwind/card";
import { Send, CheckCircle2, Eye, XCircle } from "lucide-react";
import { getFormattedMetrics } from "../../../pages/whatsapp/utils/analyticsCalculations";

export const KeyMetrics = ({ dailyData }) => {
  const {
    totalAttemptedFormatted,
    totalSentFormatted,
    totalDeliveredFormatted,
    totalReadFormatted,
    totalFailedFormatted,
  } = getFormattedMetrics(dailyData, 2);

  const stats = [
    { label: "Attempted", value: totalAttemptedFormatted, icon: Send, color: "text-indigo-600 bg-indigo-50 dark:bg-indigo-900/20 dark:text-indigo-400" },
    { label: "Sent", value: totalSentFormatted, icon: Send, color: "text-blue-600 bg-blue-50 dark:bg-blue-900/20 dark:text-blue-400" },
    { label: "Delivered", value: totalDeliveredFormatted, icon: CheckCircle2, color: "text-green-600 bg-green-50 dark:bg-green-900/20 dark:text-green-400" },
    { label: "Read", value: totalReadFormatted, icon: Eye, color: "text-teal-600 bg-teal-50 dark:bg-teal-900/20 dark:text-teal-400" },
    { label: "Failed", value: totalFailedFormatted, icon: XCircle, color: "text-red-600 bg-red-50 dark:bg-red-900/20 dark:text-red-400" },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
      {stats.map((stat, i) => (
        <Card key={stat.label} className="border-gray-100 dark:border-slate-800 bg-white dark:bg-slate-900">
          <CardContent className="p-6">
            <div className="flex items-start justify-between mb-4">
              <div className={`p-2.5 rounded-xl ${stat.color}`}>
                <stat.icon className="h-5 w-5" />
              </div>
              <span className="text-gray-400 dark:text-gray-500 text-sm font-medium">--</span>
            </div>
            <p className="text-3xl font-bold text-gray-900 dark:text-white">{stat.value}</p>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">{stat.label}</p>
            {stat.subtext && <p className="text-xs text-gray-400 dark:text-gray-500 mt-0.5">{stat.subtext}</p>}
          </CardContent>
        </Card>
      ))}
    </div>
  );
};